import { useParams } from 'react-router';
import SessionContainer from '~/components/session-container/session-container';

export default function VibeSession() {
  const { sessionId } = useParams<{ sessionId: string }>();

  return <SessionContainer sessionId={sessionId} />;
}
